var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-navbar',{attrs:{"type":"dark","variant":"dark"}},[_c('b-navbar-nav',[_c('b-nav-item',{attrs:{"href":"#"}},[_vm._v("Home")]),_c('b-nav-item',{attrs:{"href":"#"}},[_vm._v("Login")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }